module.exports = __webpack_public_path__ + "img/user.2ae981f4.svg";